export enum Vendor {
  FILE_UPLOAD = 'FILE_UPLOAD',
  LABPANO = 'LABPANO',
  PIXELLOT = 'PIXELLOT',
  PLAYSIGHT = 'PLAYSIGHT',
  SAVE_MY_PLAY = 'SAVE_MY_PLAY',
  SYNERGY = 'SYNERGY',
  URL_UPLOAD = 'URL_UPLOAD',
}
